<template>
  <div class="calculations-menu">
    <div class="heading d-flex justify-content-between">
      <span class="title">{{ $t('motor.menu.calculation') }}</span>
    </div>
    <stats-item
      tooltip-key="tooltip_motorconfig_calc_torque"
      :label="$t('motor.menu.couple')"
      :unit="getUnitString"
      :value="getTorqueCalculation(preferences.pressure, preferences.cc, true)"
    ></stats-item>
    <stats-item
      tooltip-key="tooltip_motorconfig_calc_rpm"
      :label="$t('motor.menu.rpm')"
      unit="rpm"
      :value="getRpmCalculation(preferences.lpm, preferences.cc)"
    ></stats-item>
    <stats-item
      tooltip-key="tooltip_motorconfig_calc_power"
      :label="$t('motor.menu.power')"
      unit="kw"
      :value="getPowerCalculation(getTorqueCalculation(preferences.pressure, preferences.cc), getRpmCalculation(preferences.lpm, preferences.cc), true)"
    ></stats-item>
  </div>
</template>

<script>
import StatsItem from '@/components/hose/components/StatsItem';
import { mapGetters } from 'vuex';

const {
  getRpmCalculation,
  getTorqueCalculation,
  getPowerCalculation,
} = require('@/helpers/motorCalculations');

export default {
  name: 'CalculationsMenu',
  components: {
    StatsItem,
  },
  computed: {
    ...mapGetters({
      preferences: 'build/motorConfig/getMotorPreferences',
    }),
    getUnitString() {
      return this.preferences.unit === 'newton' ? 'Nm' : 'Kgm';
    },
  },
  methods: {
    getRpmCalculation,
    getTorqueCalculation,
    getPowerCalculation,
  }
};
</script>

<style scoped lang="scss">
.calculations-menu {
  grid-row-start: 1;
  grid-row-end: 3;
  padding: 16px;
  background-color: #FAFAFA;
  max-height: 136px;
  max-width: 270px;
  min-width: 270px;
  margin-left: auto;
  border-right: 2px solid #EBEBEB;
  border-bottom: 2px solid #EBEBEB;
}
</style>